import {
  getCommandFromFormValues as getFileCommandFromFormValues,
  getInitialFormValuesFromApiValue as getFileInitialFormValuesFromApiValue,
} from './fileNormalizer';

export function getInitialFormValuesFromApiValue(medias, fileUrlPrefix) {
  return medias.map(media => {
    let normalizedMedia = {
      title: media.title,
      description: media.description,
      __TYPE__: media.__TYPE__,
      id: media.id,
      alt: media?.alt
    };

    if (media.__TYPE__ === 'fileMedia') {
      normalizedMedia.file = getFileInitialFormValuesFromApiValue(
        media.file,
        fileUrlPrefix
      );
    } else {
      normalizedMedia.url = media.url;
    }

    return normalizedMedia;
  });
}

export function getCommandFromFormValues(formMedias) {
  return formMedias.map(media => {
    let normalizedMedia = {
      title: media.title,
      description: media.description,
      __TYPE__: media.__TYPE__,
      mediaId: media.id,
      alt: media.alt
    };

    if (media.__TYPE__ === 'fileMedia') {
      normalizedMedia.file = getFileCommandFromFormValues(media.file);
    } else {
      normalizedMedia.url = media.url;
    }

    return normalizedMedia;
  });
}
